import React from "react";
import styled from "styled-components";

import { BACK_ICON } from '../../icons';
import { BREAK_POINTS } from '../../constants';

const Wrapper = styled.div`
  max-width: 1180px;
  margin: 37px auto 0;
  position: relative;

  @media (max-width: ${BREAK_POINTS.TABLET}px) {
    margin: 32px auto 0;
    padding: 0 32px;
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    margin: 24px auto 0;
    padding: 0 20px;
  }
`;

const InnerWrapper = styled.div`
  width: 100%;
  max-width: 758px;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.83px;
  color: #505050;

  /* 타이틀 최대 두 줄 까지 노출 */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: ${BREAK_POINTS.TABLET}px) {
    font-size: 22px;
    letter-spacing: -0.75px;
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    font-size: 20px;
    letter-spacing: -0.65px;
  }
`;

const Date = styled.p`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: -0.27px;
  color: #949cca;
  margin: 20px 0 40px;

  @media (max-width: ${BREAK_POINTS.TABLET}px) {
    font-size: 13px;
    margin: 16px 0 32px;
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    /* font-size: 12px; */
    /* margin: 12px 0 24px; */

    display: none;
  }
`;

const Content = styled.div`
  white-space: pre-wrap;
  word-break: keep-all;
  line-height: 1.8;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.88;
  letter-spacing: -0.5px;
  color: #969696;
  margin: 40px 0;

  @media (max-width: ${BREAK_POINTS.TABLET}px) {
    font-size: 15px;
    line-height: 1.8;
    margin: 32px 0;
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    font-size: 12px;
    line-height: 1.7;
    margin: 24px 0;
  }
`;

const Icon = styled.img`
  width: 32px;
  height: 32px;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;

  @media (max-width: ${BREAK_POINTS.TABLET}px) {
    position: static;
    margin: 18px 0;
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    position: static;
    margin: 16px 0;
  }
`;

const ImageWrapper = styled.div`
  width: 100%;
  margin: 40px 0;

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  @media (max-width: ${BREAK_POINTS.TABLET}px) {
    margin: 32px 0;
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
    margin-top: 24px;
    margin-bottom: 24px;
  }
`;

const PressDetailPresenter = ({ pressDetail, handleBack }) => {

  return (
    <Wrapper>
      <Icon src={BACK_ICON} onClick={handleBack} />
      <InnerWrapper>
        <Title>{pressDetail.title}</Title>
        <Date>{pressDetail.date}</Date>

        {pressDetail.image && <ImageWrapper>
          <img src={pressDetail.image} alt={pressDetail.title} />
        </ImageWrapper>}

        <Content>{pressDetail.content}</Content>
      </InnerWrapper>
    </Wrapper>
  );
};

export default PressDetailPresenter;
